const modifiedFields = [
  'templateDescModel',
  'templateNameModel',
  'templateRules',
  'notificationsModel'
];
const modifiedFieldCustom = {
  templateRules: [
    'eventLevel',
    'metricKey',
    'metricFunction',
    'prefix',
    'ftCount',
    'thresholdMax',
    'thresholdMin',
    'thresholdItem',
    'check_statistics',
    'statisticsType',
    'statisticsPeriod',
    'eventOccurTimeZone'
  ],
  notificationsModel: ['recipientKey', 'recipientName', 'notificationMethods', 'recipientType']
};
const sortByFields = {
  notificationsModel: ['recipientName'],
  orderBy: ['asc']
};

export default { modifiedFields, modifiedFieldCustom, sortByFields };
